The URL of the light mode image to indicate candidate identity has been verified.
This should be the default image used if no preference is indicated.
